<template>
  <b-modal
    centered
    id="link-receipts"
    modal-class="overflow-hidden"
    static
    scrollable
    @hidden="onHidden"
  >
    <template #modal-header="{ close }">
      <h5>Liên kết phiếu thu</h5>
      <b-button size="sm" variant="light" @click="close()"> x </b-button>
    </template>
    <div>
      <div class="form-group">
        <label>Nhập mã PT cần liên kết</label>
        <Select2 v-model="receiptIdTo" :options="dataListLink" placeholder="Chọn phiếu thu" />
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <b-button size="sm" variant="light" @click="cancel()"> Hủy bỏ </b-button>
      <b-button size="sm" variant="primary" @click="updateLinked"> Xác nhận </b-button>
    </template>
  </b-modal>
</template>

<script>
  export default {
    props: {
      receiptIdFrom: {
        type: String,
        default: '',
      },
      contractId: {
        type: String,
        default: '',
      },
      dataListLink: {
        type: Array,
        default: Array,
      },
    },
    data() {
      return {
        receiptIdTo: '',
      }
    },

    methods: {
      async updateLinked() {
        const data = {
          receiptIdFrom: this.receiptIdFrom,
          receiptIdTo: this.receiptIdTo,
        }
        this.$emit('updateLinked', data)
      },
      onHidden() {
        this.$emit('onHidden')
      },
    },
  }
</script>

<style scoped></style>
